import { categoryGroups } from '@cx-modules/constants';

/**
 * i18n namespaces for the sport-specific outright bettype override files published by the CMS
 * (e.g. `bettype_baseball_outright`). Derived once from the static `categoryGroups` list so it
 * is not recomputed on every render. The `typeof === 'string'` guard narrows the type so the
 * template literal never produces `bettype_undefined_outright`.
 */
export const bettypeOutrightNamespaces = categoryGroups
  .filter(cg => typeof cg.translationFile === 'string')
  .map(cg => `bettype_${cg.translationFile}_outright`);
